module.exports = "/_next/static/images/40c37e9447f7a889ffdd20207474c68a-man-with-cellphone-lg@3x.jpg";